// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/noop.js
// module id = 348
// module chunks = 115